export default "__VITE_ASSET__WQEwWBRt__"